(function(){
  function money(cents){ return (cents/100).toLocaleString('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }

  // precio (en céntimos) de la variante seleccionada
  function variantPrice(){
    var sel=document.querySelector('[name="id"], select[name="id"], input[name="id"]:checked');
    var vol=document.getElementById('sk-vol');
    if(sel && vol && vol.dataset.variants){
      var map={};
      vol.dataset.variants.split(',').forEach(function(p){var kv=p.split(':');map[kv[0]]=+kv[1];});
      if(map[sel.value]!=null) return map[sel.value];
    }
    // fallback: precio que Shopify deje en el bloque de precio del tema
    return null;
  }

  function qty(){ var q=document.querySelector('input[name="quantity"]'); return q?(parseInt(q.value,10)||0):0; }

  // tramo activo según cantidad -> devuelve el multiplicador (1 / .9 / .8)
  function activeMult(n){
    var mult=1;
    document.querySelectorAll('#sk-vol .sk-vol__row').forEach(function(r){
      var min=+r.dataset.min, max=+r.dataset.max, active=n>=min&&n<=max;
      r.classList.toggle('is-active', active);
      if(active){ var pc=r.querySelector('.sk-vol__price'); if(pc) mult=+pc.dataset.mult||1; }
    });
    return mult;
  }

  function upd(){
    var base=variantPrice();               // céntimos de la variante elegida
    var n=qty();

    // 1) TABLA DE VOLUMEN: recalcular los 3 precios con el precio de la variante
    if(base!=null){
      document.querySelectorAll('#sk-vol .sk-vol__price').forEach(function(pc){
        var m=+pc.dataset.mult||1;
        pc.textContent=money(base*m);
      });
    }
    var mult=activeMult(n);

    // 2) RESUMEN
    var res=document.getElementById('sk-resumen');
    if(res && base!=null){
      var prod=(window.meta&&meta.product&&meta.product.title)||document.querySelector('.product__title,h1')&&document.querySelector('.product__title,h1').textContent.trim()||'';
      // color y personalización de las opciones seleccionadas
      var color='', perso='';
      document.querySelectorAll('[data-option-name],fieldset[name]').forEach(function(){});
      var sel=document.querySelector('[name="id"]');
      // leer valores de las opciones activas del tema Venue
      var opts=document.querySelectorAll('.product-form__input, variant-selects fieldset, .variant-input-wrap');
      // método robusto: variante seleccionada -> title "Color / Personalización"
      var vtitle='';
      var found=res.querySelector('[data-sk="color"]');
      // usamos la etiqueta del selector nativo si existe
      var colorSel=document.querySelector('select[name="options[Color]"], input[name="options[Color]"]:checked');
      var persoSel=document.querySelector('select[name="options[Personalización]"], input[name="options[Personalización]"]:checked');
      if(colorSel) color=colorSel.value||'';
      if(persoSel) perso=persoSel.value||'';

      var unit=base*mult;                    // precio/ud del tramo activo
      set(res,'producto',prod);
      set(res,'color',color||'—');
      set(res,'unidades', n?n:'—');
      set(res,'precio', money(unit));
      set(res,'total', n?money(unit*n):'—');

      // badge según personalización
      var badge=res.querySelector('.sk-res__badge');
      if(badge){
        if(perso && perso.toLowerCase().indexOf('sin')===0){ badge.textContent='Sin personalización'; badge.style.display='inline-block'; }
        else { badge.textContent='✓ Personalización incluida'; badge.style.display='inline-block'; }
      }
    }
  }
  function set(root,key,val){ var el=root.querySelector('[data-sk="'+key+'"]'); if(el) el.textContent=val; }

  function init(){
    if(!document.getElementById('sk-vol') && !document.getElementById('sk-resumen')) return;
    upd();
    document.addEventListener('input',upd,true);
    document.addEventListener('change',upd,true);
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();